import './App.css';
import "zone.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import Home from './components/Home/Home';
import Footer from './components/Footer/footer';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Pricing from './components/Pricing/Pricing';
import Loader from './components/Loader/Loader';
import ContactUs from './components/ContactUs/ContactUs';
import ErrorPage from './components/ErrorPage/ErrorPage';
import Login from './components/Login/Login';
import { useEffect, useState } from 'react';
import Forces1 from './components/Forces1/Forces1';
import Otp from './components/Otp/Otp';
import SignUp from './components/SignUp/SignUp';
import Cart from './components/Cart/Cart';
import PlaceOrder from './components/PlaceOrder/PlaceOrder';
import Orders from './components/Orders/Orders';
import OrderInfo from './components/OrderInfo/OrderInfo';
import Profile from './components/Profile/Profile';
import Wallet from './components/Wallet/Wallet';
import OrientationChange from './components/OrientationChange/OrientationChange';
import LostMisplaced from './components/LostMisplaced/LostMisplaced';
import "./components/Registration/Registration.css";
import {WhatsAppOutlined, PhoneOutlined} from "@ant-design/icons"

function App () {
  let [ login, setLogin ] = useState( false );
  let [ phone, setPhone ] = useState( "" );
  let [ cartObject, setCartObject ] = useState( {} );
  let [ details, setDetails ] = useState( {
    name: "",
    phone: "",
    email: "",
    address: ""
  } );

  function settingDetails ( object ) {
    setDetails( object );
    setPhone( object.phone );
  }

  return (
    <BrowserRouter>
      <div className="App">
        <Loader />
        <OrientationChange />
        <Header settingDetails={settingDetails} setLogin={setLogin} />
        <Routes>
          <Route path='*' exact={true} element={<ErrorPage />} />
          <Route path='/' element={<Home settingDetails={settingDetails} />} />
          <Route path='/otp' element={<Otp phone={phone} settingDetails={settingDetails} details={details} />} />
          <Route path='/signup' element={<SignUp details={details} login={login} />} />
          <Route path='/login' element={<Login details={details} settingDetails={settingDetails} />} />
          <Route path='/pricing' element={<Pricing settingDetails={settingDetails} />} />
          <Route path='/franchise' element={<Forces1 settingDetails={settingDetails} />} />
          <Route path='/contact' element={<ContactUs settingDetails={settingDetails} />} />
          <Route path='/cart' element={<Cart details={details} setCartObject={setCartObject} settingDetails={settingDetails} />} />
          <Route path='/place-order' element={<PlaceOrder details={details} cartObject={cartObject} />} />
          <Route path='/orders' element={<Orders details={details} settingDetails={settingDetails} />} />
          <Route path='/orders/:docId' element={<OrderInfo details={details} settingDetails={settingDetails} />} />
          <Route path='/profile' element={<Profile settingDetails={settingDetails} />} />
          <Route path='/wallet' element={<Wallet details={details} settingDetails={settingDetails} />} />
          <Route path='/lost-misplaced' element={<LostMisplaced settingDetails={settingDetails} />} />
        </Routes>
        <div className='floating-button phone' onClick={event => window.open( "tel:+917022578103", "_self" )}><PhoneOutlined /></div>
        <div className='floating-button' onClick={event => window.open( "https://wa.me/+917022578103", "_blank" )}><WhatsAppOutlined /></div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
